import { Button } from '@/components/ui/Button';
import { Link } from 'react-router-dom';

const SuccessFulRegistration = () => {
  return (
    <div className="flex flex-col gap-2 h-screen w-full justify-center items-center">
      <h1>Registraci dokončíte potvrzením v e-mailu.</h1>

      <Link data-testid="successful-registration-login-link" to="/login">
        <Button data-testid="successful-registration-login-btn">Zpět na příhlášení</Button>
      </Link>
    </div>
  );
};

export default SuccessFulRegistration;
